<div class="container">

    <div class="col-md-12 lease_table ">
        <div>
            <div class="migration_detials">Moblie Push Notification </div>
            <div class="col-md-12">
                <div>
                    <form [formGroup]="migrationForm">
                        <div class="row mt-3">
                            <div class="col-sm-6 d-flex align-items-center">
                                <mat-label class="me-2" style="min-width: 120px;">City </mat-label>
                                <mat-select class="form-control" placeholder="Select City"
                                    formControlName="CityControl">
                                    <input matInput [matAutocomplete]="classauto" formControlName="CityControl2"
                                        class="intbtn" placeholder="select Class">
                                    <mat-autocomplete autoActiveFirstOption
                                        #classauto="matAutocomplete"></mat-autocomplete>
                                    <mat-option *ngFor="let class of cityOptions | async" (click)="getCampus(class)"
                                        (click)="clearCampus()" [value]="class?.cityName">
                                        {{class.cityName}}</mat-option>
                                </mat-select>
                            </div>
                            <div class="col-sm-6 d-flex align-items-center">
                                <mat-label class="me-2" style="min-width: 120px;">Campus </mat-label>
                                <mat-select class="form-control" placeholder="Select Campus"
                                    formControlName="CampusControl">
                                    <input matInput [matAutocomplete]="classauto" formControlName="CampusControl2"
                                        class="intbtn" placeholder="select Class">
                                    <mat-autocomplete autoActiveFirstOption
                                        #classauto="matAutocomplete"></mat-autocomplete>
                                    <mat-option *ngFor="let class of campusOptions | async" (click)="getsection(class)"
                                        (click)="clearCampus()" [value]="class?.campusName">
                                        {{class.campusName}}</mat-option>
                                </mat-select>
                            </div>
                        </div>
                        <div class="row mt-3">
                            <div class="col-sm-6 d-flex align-items-center">
                                <mat-label class="me-2" style="min-width: 120px;">Section</mat-label>
                                <mat-select class="form-control" placeholder="Select Section"
                                    formControlName="SectionControl" multiple>
                                    <input matInput [matAutocomplete]="classauto" formControlName="SectionControl2"
                                        class="intbtn" placeholder="select Class">
                                    <mat-autocomplete autoActiveFirstOption
                                        #classauto="matAutocomplete"></mat-autocomplete>
                                    <mat-option *ngFor="let class of sectionOptions | async" (click)="head(class)"
                                        (click)="clearCampus()" [value]="class?.sectionId">
                                        {{class.sectionName}}</mat-option>
                                </mat-select>
                            </div>
                            <div class="col-sm-6 d-flex align-items-center ">
                                <mat-label class="me-2" style="min-width: 120px;">Fee head</mat-label>
                                <mat-select class="form-control" placeholder="Select Feehead"
                                    formControlName="HeadControl">
                                    <input matInput [matAutocomplete]="classauto" formControlName="HeadControl2"
                                        class="intbtn" placeholder="select Class">
                                    <mat-autocomplete autoActiveFirstOption
                                        #classauto="matAutocomplete"></mat-autocomplete>
                                    <mat-option *ngFor="let class of headOptions | async" (click)="getCampus1()"
                                        (click)="clearCampus()" [value]="class?.headName">
                                        {{class.headName}}</mat-option>
                                </mat-select>
                            </div>

                        </div>
                        <div class="row mt-3">
                            <div class="col-sm-6 d-flex align-items-center ">
                                <mat-label class="me-2" style="min-width: 120px;">Template</mat-label>
                                <mat-select class="form-control" placeholder="Select Template"
                                    formControlName="template">
                                    <input matInput [matAutocomplete]="classauto" formControlName="templatel2"
                                        class="intbtn" placeholder="select Class">
                                    <mat-autocomplete autoActiveFirstOption
                                        #classauto="matAutocomplete"></mat-autocomplete>
                                    <mat-option *ngFor="let class of template | async" (click)="getCampus(class)"
                                        (click)="clearCampus()" [value]="class?.headName">
                                        {{class.headName}}</mat-option>
                                </mat-select>
                            </div>
                            <div class="col-sm-6 d-flex align-items-center ">
                                <mat-label style="min-width: 130px;">Schedule date</mat-label>
                                <input matInput [matDatepicker]="picker" [min]="minDate" formControlName="selectedDate"
                                    class="form-control" placeholder="DD-MMM-YYYY"/>
                                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                <mat-datepicker #picker></mat-datepicker>

                            </div>

                        </div>
                    </form>
                    <div class="col-lg-12 text-center mt-3">
                        <button type="button" class="cctv_notebtn" (click)="savestudent()">Send Notification</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<ngx-spinner class="spinner" bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple">
    <p style="font-size: 20px; color: white">Loading...</p>
</ngx-spinner>